export const CHECK_TOKEN_TELEGRAM = 'checkTokenTelegram'
export const SEND_MESSAGE = 'sendMessage'
export const SEND_IMAGE = 'sendImage'
export const BROADCAST_MESSAGE = 'broadcastMessage'
export const BROADCAST_IMAGE = 'broadcastImage'
export const BROADCAST_EVERYONE = 'broadcastEveryone'
export const SEND_PROMO = 'sendPromo'
